import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('cashCoupon')

export const FETCH_LIST = createType('FETCH_LIST')
export const LIST_FETCHED = createType('LIST_FETCHED')
export const SHOW_CASH_COUPON_DIALOG = createType('SHOW_CASH_COUPON_DIALOG')
export const DELETE_CASH_COUPON = createType('DELETE_CASH_COUPON')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const UPDATED = createType('UPDATED')